type VoucherQuantityLimitExceededIconProps = {
  size?: number;
};

export const VoucherQuantityLimitExceededIcon = ({size = 162}: VoucherQuantityLimitExceededIconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 163 162" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="81.4965" cy="80.9965" r="80.9965" fill="#E82026" fill-opacity="0.03" />
      <circle cx="81.4966" cy="80.9964" r="66.0591" fill="#E82026" fill-opacity="0.05" />
      <circle cx="81.4969" cy="80.9967" r="51.9422" fill="#E82026" fill-opacity="0.07" />
      <g filter="url(#filter0_i_12876_189629)">
        <path
          d="M40.5972 91.4111C35.4896 98.1723 39.6232 107.927 48.0337 108.96L106.239 116.106C114.649 117.139 121.02 108.674 117.7 100.878L94.7694 47.0367C91.456 39.2568 80.969 37.9691 75.8719 44.7164L40.5972 91.4111Z"
          fill="#E82026"
        />
      </g>
      <path
        opacity="0.88"
        d="M75.8725 44.7157C80.9697 37.969 91.4562 39.2565 94.7697 47.036L106.949 75.6338C96.5365 88.0904 80.2177 95.179 62.9045 93.0533C56.0621 92.2131 49.7192 90.0119 44.1108 86.7579L75.8725 44.7157Z"
        fill="#FF787C"
      />
      <rect x="79.2038" y="59.59" width="8.8" height="22" rx="4.4" transform="rotate(7 79.2038 59.59)" fill="white" />
      <rect
        x="75.4502"
        y="90.1602"
        width="8.8"
        height="8.8"
        rx="4.4"
        transform="rotate(7 75.4502 90.1602)"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_i_12876_189629"
          x="38.3615"
          y="40.3452"
          width="80.2345"
          height="75.8469"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-4.4" dy="-6.6" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.639216 0 0 0 0 0.0156863 0 0 0 0 0.0431373 0 0 0 0.75 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_12876_189629" />
        </filter>
      </defs>
    </svg>
  );
};
